.overlay {
  align-items: center;
  display: flex;
  inset: 0;
  justify-content: center;
  // Gutter so a modal never touches the screen edges on small viewports — the
  // content's `width: 100%` then resolves to `100vw - 32px` on mobile (the
  // content max-width still caps it on desktop). Keeps every modal responsive.
  padding: 16px;
  position: fixed;
  // Above page-level overlays like the Leaflet map controls (z-index: 1000)
  // so a modal is never bled through; stays below the global toaster (9999).
  z-index: 2000;
}

.backdrop {
  // Legacy parity: legacy dialogs dim the page with `bg-black/80`; the old 0.2
  // read as barely-there. Darker keeps focus on the modal.
  background: rgba(0, 0, 0, 0.6);
  border: none;
  cursor: default;
  inset: 0;
  position: absolute;
}

.content {
  // Modal colour scheme follows the legacy site (blue primary + light blue-grey
  // borders), scoped to the modal so it matches legacy without recolouring the
  // rest of the app (page-level buttons keep the app's brand). Components inside
  // — Buttons, inputs, cards — read these tokens, so they all inherit it.
  --color-primary: hsl(208deg 76.9% 47.5%);
  --color-primary-foreground: #fff;
  --color-primary-hover: hsl(208deg 76.9% 41%);
  --color-border: hsl(208deg 30% 90%);
  --color-ring: hsl(208deg 76.9% 47.5%);
  --color-focus: hsl(208deg 76.9% 47.5%);
  background: var(--color-background);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  // Cap to the viewport and scroll long content instead of overflowing
  // off-screen (where the top/bottom would be unreachable).
  max-height: calc(100vh - 32px);
  max-width: 660px;
  overflow-y: auto;
  position: relative;
  width: 100%;
  z-index: 10;
}

.header {
  align-items: center;
  // Stay visible (title + close) while the body scrolls.
  background: var(--color-background);
  display: flex;
  justify-content: space-between;
  padding: 24px 32px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.closeBtn {
  align-items: center;
  border-radius: 6px;
  color: var(--color-muted);
  display: flex;
  height: 32px;
  justify-content: center;
  transition: background-color 0.15s;
  width: 32px;

  &:hover {
    background: var(--color-secondary);
  }
}

.footer {
  align-items: center;
  // Keep the action buttons reachable when the body scrolls.
  background: var(--color-background);
  bottom: 0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 16px 32px;
  position: sticky;
  z-index: 1;
}
